<template>
  <el-dialog
    :title="`发送到租户`"
    :visible.sync="show"
    width="600px"
    :close-on-click-modal="false"
    >
    
    <div class="d-flex">
      <label class="required mr10">租户名称：</label>
      <el-select
        v-model="tenant_ids"
        remote
        filterable
        clearable
        multiple
        :remote-method="getTenantsOpts"
        @focus="getTenantsOpts()"
      >
        <el-option
          v-for="item in tenantOpts"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </div>
    
    <div slot="footer" class="d-flex right">
      <el-button
        @click="close"
      >关闭</el-button>
      <el-button 
        type="primary" 
        @click="confirm"
      >确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    getTenantOpts,
    tagSendToTenant
  } from '@/api.js';
  export default {
    name: 'SendToTenant',
    data() {
      return {
        show: false,
        tenant_ids: [],
        tenantOpts: [],
        templateId: 0
      }
    },
    methods: {
      open(templateId = 0) {
        this.reset()
        this.templateId = templateId
        this.show = true
      },
      reset() {
        this.tenantOpts = []
        this.tenant_ids = []
      },
      getTenantsOpts(name = undefined) {
        return this.$request('get', getTenantOpts, { name })
        .then(res => {
          this.tenantOpts = res || []
        })
      },
      confirm() {
        // 保存
        if (!this.tenant_ids || !this.tenant_ids.length) {
          this.$message.error(`租户不能为空`)
          return
        }

        const params = {
          id: this.templateId,
          tenant_ids: this.tenant_ids
        }

        this.$request('post', tagSendToTenant, params)
        .then(res => {
          if (res) {
            this.close()
            this.$message.success(`操作成功`)
            this.$emit('refresh')
          }
        })
      },
      close() {
        this.show = false
      }
    }
  }
</script>